window.initMaps = function(){
    init();
};

const montserrat = { lat: 39.358226, lng: -0.601175 };
let map = null;
let marker = null;

let promiseResolve = null;
let promiseReject = null;

export function init_control(control){
    
    control.find('button.open-map').click(function(){
        open(control.find('input.lat').val(), control.find('input.lng').val(), control.hasClass('readonly'))
            .then((position) => {
                control.find('input.lat').val(position.lat.toFixed(6));
                control.find('input.lng').val(position.lng.toFixed(6));
            })
            .catch(_ => {});
    });

    control.addClass('init');

}

async function init(){
    
    map = new google.maps.Map(document.getElementById("coordinates-map"), {
        zoom: 16,
        center: montserrat,
        disableDefaultUI: true,
        zoomControl: true,
        mapTypeControl: false,
        scaleControl: false,
        streetViewControl: false,
        rotateControl: false,
        fullscreenControl: false,
        styles: [{
            featureType: 'poi',
            stylers: [
                { visibility: "off" }
            ]   
        },
        {
            featureType: 'transit',
            stylers: [
                { visibility: "off" }
            ]   
        }]
    });

    marker = new google.maps.Marker({
        position: montserrat,
        map: map,
    });
    
    marker.setDraggable(true);

    google.maps.event.addListener(marker, 'drag', function(){
        let center = marker.getPosition().toJSON();
        $('#coordinates-modal input[name="latitude"]').val(center.lat.toFixed(6));
        $('#coordinates-modal input[name="longitude"]').val(center.lng.toFixed(6));
    });

    $('#coordinates-modal').on('hidden.bs.modal', function (event) {
        if(promiseReject != null){
            promiseReject();
        }
    });

    $('#coordinates-modal .submit').click(function(){
        if(promiseResolve != null){
            promiseResolve(marker.getPosition().toJSON());
            $('#coordinates-modal').modal('hide');
        }
    });
      
}

export function open(lat, lng, readonly){

    let hide = false;

    if(
        typeof lat == 'undefined'
        || lat === ''
        || lat === null
    ){
        
        lat = montserrat.lat;
        
        if(readonly){
            hide = true;
        }

    }

    if(
        typeof lng == 'undefined'
        || lng === ''
        || lng === null
    ){

        lng = montserrat.lng;

        if(readonly){
            hide = true;
        }

    }

    if(typeof readonly == 'undefined'){
        readonly = false;
    }

    let center = {
        lat: parseFloat(lat),
        lng: parseFloat(lng)
    }

    map.setCenter(center);
    map.setZoom(16);

    marker.setPosition(center);
    $('#coordinates-modal input[name="longitude"]').val(center.lng.toFixed(6));
    $('#coordinates-modal input[name="latitude"]').val(center.lat.toFixed(6));

    marker.setDraggable(!readonly);
    marker.setMap(hide ? null : map);

    $('#coordinates-modal').modal('show');

    return new Promise((resolve, reject) => {
        promiseResolve = resolve;
        promiseReject = reject;
    });

}